<div class="addons-page page-shell">
  <div class="header">
    <div class="header-left">
      <span class="header-title">{{ "menu.addons" | translate }}</span>
      <div class="header-tabs" role="tablist">
        <button
          type="button"
          role="tab"
          class="header-tab"
          [class.header-tab--active]="selectedTabIndex === 0"
          [attr.aria-selected]="selectedTabIndex === 0"
          (click)="onTabChange(0)"
        >
          {{ "addons.banners.label" | translate }}
        </button>
        <button
          type="button"
          role="tab"
          class="header-tab"
          [class.header-tab--active]="selectedTabIndex === 1"
          [attr.aria-selected]="selectedTabIndex === 1"
          (click)="onTabChange(1)"
        >
          {{ "addons.disclaimers.label" | translate }}
        </button>
        <button
          type="button"
          role="tab"
          class="header-tab"
          [class.header-tab--active]="selectedTabIndex === 2"
          [attr.aria-selected]="selectedTabIndex === 2"
          (click)="onTabChange(2)"
        >
          {{ "addons.links.label" | translate }}
        </button>
      </div>
    </div>
    <div class="header-buttons">
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="addItem()"
      >
        <mat-icon>add</mat-icon>
        {{ addLabelKey | translate }}
      </button>
    </div>
  </div>

  <div class="addons-content">
    <div [hidden]="selectedTabIndex !== 0">
      <app-banners></app-banners>
    </div>
    <div [hidden]="selectedTabIndex !== 1">
      <app-disclaimers></app-disclaimers>
    </div>
    <div [hidden]="selectedTabIndex !== 2">
      <app-links></app-links>
    </div>
  </div>
</div>
